export default "__VITE_ASSET__c158cd14__"